module.exports = __webpack_public_path__ + "img/dustbin.f03c66f5.svg";